export default "__VITE_ASSET__045ed640__"